var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagesIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.27344H3.125C2.77982 4.27344 2.5 4.55326 2.5 4.89844V16.1484C2.5 16.4936 2.77982 16.7734 3.125 16.7734H16.875C17.2202 16.7734 17.5 16.4936 17.5 16.1484V4.89844C17.5 4.55326 17.2202 4.27344 16.875 4.27344Z",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.6484L6.42969 9.71868C6.48784 9.65963 6.55716 9.61273 6.63361 9.58072C6.71006 9.54871 6.79212 9.53223 6.875 9.53223C6.95788 9.53223 7.03994 9.54871 7.11639 9.58072C7.19284 9.61273 7.26216 9.65963 7.32031 9.71868L10.8047 13.2031C10.8628 13.2621 10.9322 13.309 11.0086 13.341C11.0851 13.373 11.1671 13.3895 11.25 13.3895C11.3329 13.3895 11.4149 13.373 11.4914 13.341C11.5678 13.309 11.6372 13.2621 11.6953 13.2031L13.3047 11.5937C13.3628 11.5346 13.4322 11.4877 13.5086 11.4557C13.5851 11.4237 13.6671 11.4072 13.75 11.4072C13.8329 11.4072 13.9149 11.4237 13.9914 11.4557C14.0678 11.4877 14.1372 11.5346 14.1953 11.5937L17.5 14.8984",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 9.27344C12.7053 9.27344 13.125 8.8537 13.125 8.33594C13.125 7.81817 12.7053 7.39844 12.1875 7.39844C11.6697 7.39844 11.25 7.81817 11.25 8.33594C11.25 8.8537 11.6697 9.27344 12.1875 9.27344Z",
    fill: "#969992"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesIco);
export default __webpack_public_path__ + "static/media/images_ico.46099ab53301b43164cd59f345d35b54.svg";
export { ForwardRef as ReactComponent };